import { Component, ViewChild } from '@angular/core';
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";
import { MachineListComponent } from '../machine-list/machine-list.component';

@Component({
	selector: 'machines',
	templateUrl: 'machines.html'
})

export class MachinesComponent{
    accountRole = this.userService.accountRole;
    @ViewChild(MachineListComponent) listComp : MachineListComponent

    constructor(
        private userService: UserService,
        public router: Router
    ) { };

    
    refreshList(): void {
        this.listComp.getMachines();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/machines/machines.component.ts